import { render, staticRenderFns } from "./dError.vue?vue&type=template&id=79fc28fb&scoped=true&"
import script from "./dError.vue?vue&type=script&lang=js&"
export * from "./dError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc28fb",
  null
  
)

export default component.exports